<template>
    <div class="bax-section bax-select-patient-wrap">
        <div class="container">
            <div class="bax-bg bax-bg-foot-link bax-create-patient">
                <div>
                    Processing your file, please wait. <img class="loading_animation" src="@/assets/images/loading.gif" alt="Loading" />
                </div>
            </div>
        </div>
    </div>
</template>


<script>
    import CsvService from '@/core/api/csv/csv.service3';
    import csvMixin from './csvMixin';

    export default {
        name: 'Stage2',
        mixins: [csvMixin],
        props: ['uploadCode'],
        created() {
            this.uploadFileProcess();
        },
        methods: {
            uploadFileProcess() {
                CsvService.loadCsv(this.uploadCode)
                    .then(async (res) => {
                        this.$emit('file_loaded', res.data);
                    });
            },
        },
    };
</script>

